import { View, Image } from "react-native";
import { IconButton } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import TextLabel from "./TextLabel";
import useTransactionDetailsAPI from "../../../contexts/TransactionDetailsAPIContext";
import { PanamaBank as TPanamaBank } from "../../../types";
import CardText from "../../CardText";

type Props = {
  bank?: TPanamaBank;
};

export default function PanamaBank({ bank }: Props) {
  const tailwind = useTailwind();

  if (!bank) return null;

  const { bankName, accountNumber, accountType } = bank;
  return (
    <View style={tailwind("flex-row justify-between items-center mt-2")}>
      <View style={tailwind("flex-row items-center flex-shrink-0 mr-2")}>
        <BankLogo bankName={bankName} />
        <CardText.Body text={bankName} style={tailwind("ml-2")} />
      </View>
      <View style={tailwind("flex-shrink")}>
        <CardText.Body
          text={accountNumber}
          style={tailwind("text-right mb-2")}
        />
        <TextLabel text={accountType} />
      </View>
    </View>
  );
}

function BankLogo({ bankName }: { bankName: string }) {
  const tailwind = useTailwind();

  const { withdrawBanks } = useTransactionDetailsAPI();

  const bank = withdrawBanks.find((b) => b.name === bankName);

  return (
    <View style={tailwind("h-10 w-10 items-center justify-center")}>
      {bank ? (
        <Image source={bank.logo} style={tailwind("h-8 w-8")} />
      ) : (
        // fallback incase bank not found
        <IconButton icon="bank" style={tailwind("m-0 p-0")} />
      )}
    </View>
  );
}
